(function () {
  'use strict';

  var TARGET = 'https://saname-health-hub.replit.app/recipes';
  var path = window.location.pathname || '';

  // Hard client-side fallback for any legacy SANAME recipe route.
  if (path === '/blogs/recipes' || path.indexOf('/blogs/recipes/') === 0) {
    window.location.replace(TARGET);
    return;
  }

  function isLegacyRecipeUrl(href) {
    if (!href) return false;
    try {
      var url = new URL(href, window.location.origin);
      return url.origin === window.location.origin &&
        (url.pathname === '/blogs/recipes' || url.pathname.indexOf('/blogs/recipes/') === 0);
    } catch (e) {
      return false;
    }
  }

  function updateLink(link) {
    if (link && isLegacyRecipeUrl(link.getAttribute('href'))) {
      link.setAttribute('href', TARGET);
    }
  }

  function updateAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(updateLink);
  }

  updateAll(document);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    if (isLegacyRecipeUrl(link.getAttribute('href'))) {
      event.preventDefault();
      window.location.assign(TARGET);
    }
  }, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) updateLink(node);
          updateAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
